<script lang="ts">
  import { browser } from '$app/environment';

  import { onDestroy, onMount } from 'svelte';

  import { pointerEventName, type CursorAction } from '@shared/libs/tools';
  import { Icon } from '@shared/ui/icon';
  import { is } from '@shared/utils';

  let isPointerActive = false;
  let isVisible = false;
  let isDragging = false;

  let positionX = 0;
  let positionY = 0;

  let isRightArrow = false;
  let isLeftArrow = false;
  let isView = false;
  let isDragged = false;

  $: isIdle = !isRightArrow && !isLeftArrow && !isView && !isDragged;

  const setIsVisible = (val: boolean) => {
    if (val) {
      isVisible = true;
    } else {
      setTimeout(() => {
        if (!isPointerActive) {
          isVisible = false;
        }
      }, 700);
    }
  };

  const handleMouseEnter = () => {
    isPointerActive = true;
    setIsVisible(true);
  };
  const handleMouseLeave = () => {
    isPointerActive = false;
    setIsVisible(false);
  };

  const handleMouseMove = (e: MouseEvent) => {
    requestAnimationFrame(() => {
      if (isPointerActive) {
        positionX = e.clientX;
        positionY = e.clientY;
      }
      if (isDragging) {
        isDragged = true;
      }
    });
  };

  const handleDragStart = () => {
    isDragging = true;
  };
  const handleDragEnd = () => {
    isDragging = false;
    isDragged = false;
  };

  const handleCursorAction = (action: CustomEvent): void => {
    const actionType: CursorAction = action.detail.cursor;
    const isShown: boolean = action.detail.appearance;

    switch (actionType) {
      case 'SET_LEFT_ARROW':
        isLeftArrow = isShown;
        break;
      case 'SET_RIGHT_ARROW':
        isRightArrow = isShown;
        break;
      case 'SET_VIEW':
        isView = isShown;
        break;
    }
  };

  onMount(() => {
    if (browser) document.addEventListener(pointerEventName, handleCursorAction);
  });

  onDestroy(() => {
    if (browser) document.removeEventListener(pointerEventName, handleCursorAction);
  });
</script>

<div
  on:mouseenter="{handleMouseEnter}"
  on:mouseleave="{handleMouseLeave}"
  on:mousedown="{handleDragStart}"
  on:mouseup="{handleDragEnd}"
  on:mousemove="{handleMouseMove}"
  on:mouseleave="{handleDragEnd}"
  role="button"
  tabindex="0"
>
  <div
    class="
			hidden md:block
            {isPointerActive ? 'opacity-1' : 'opacity-0'}
            {isVisible ? 'visible' : 'invisible'}
            bg-dark-400/50 pointer-events-none fixed left-0 top-0 z-40 -ml-12 -mt-12 h-24 w-24 rounded-full backdrop-blur-sm"
    style="
            transform: translate3d({positionX}px, {positionY}px, 0) scale({!isIdle
      ? isDragging
        ? '1'
        : '0.6'
      : '0.2'});
            transition: transform 0.15s ease-out, opacity 0.5s linear;
        "
  ></div>
  <div
    class="
			hidden md:flex
            {isPointerActive ? 'opacity-1' : 'opacity-0'}
            {isVisible ? 'visible' : 'invisible'}
            pointer-events-none fixed left-0 top-0
            z-40 -ml-12 -mt-12 flex h-24 w-24 items-center justify-center text-white"
    style="
            transform: translate3d({positionX}px, {positionY}px, 0);
            transition: transform 0.19s ease-out, opacity 0.2s linear;;
        "
  >
    <div
      class="absolute opacity-0 transition-opacity {is(!isDragged && (isLeftArrow || isRightArrow), 'opacity-100')} {is(
        isLeftArrow,
        'rotate-180',
      )}"
    >
      <Icon name="arrowRight" />
    </div>
    <div class="absolute opacity-0 transition-opacity {is(!isDragged && isView, 'opacity-100')}">View</div>
    <div class="absolute opacity-0 transition-opacity {is(isDragged, 'opacity-100')}">Drag</div>
  </div>
  <slot />
</div>
